export const tableColors = [
    'mpOrange',
    'mpLBlue',
    'mpPurple',
    'mpGreen',
    'mpYellow'
];